import React from "react";
import InfoCard from 'gui/pages/mainRouter/pages/ad/components/commons/infoCard/InfoCard';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import FacebookLoginButtonContainer from 'data/redux/containers/facebookLoginButtonContainer';
import GoogleLoginButtonContainer from 'data/redux/containers/googleLoginButtonContainer';
import OrLine from 'gui/components/orLine';
import styles from './AuthenticationCard.module.scss';

import {Container, Grid} from '@material-ui/core';

export interface IAuthenticationCardProps {
  title?: string;
  switchCardComponent?: any;
  authenticateComponent?: any;
}

const AuthenticationCard = (props: IAuthenticationCardProps) => (
  <InfoCard
    title={props.title}
    icon={ErrorOutlineIcon}
    toolTip="מילוי פרטים"
    defaultExpanded={true}
  >
    <Container className={`${styles.AuthenticationCard}`}>
      <Grid container spacing={2}>
        <Grid item style={{marginTop: 15}} lg={12}>
          {props.switchCardComponent}
        </Grid>
        <Grid item xs={12} lg={6}>
          <FacebookLoginButtonContainer text="המשך עם פייסבוק"/>
        </Grid>
        <Grid item xs={12} lg={6}>
          <GoogleLoginButtonContainer text="המשך עם גוגל"/>
        </Grid>
      </Grid>
      <OrLine reverseMargin={-30}/>
      {props.authenticateComponent}
    </Container>
  </InfoCard>
);

AuthenticationCard.defaultProps = {
  title: "לרכישת הצעה מלאו פרטים",
};

export default AuthenticationCard;
